import { createSlice } from "@reduxjs/toolkit";
import type { DealFinderTicker } from "api/tickers/models/DealFinderTicker";
import { logoutActions } from "state/middleware/actionGroups";

export interface DealFinderState {
  defaultDeals: DealFinderTicker[];
  isDefaultDealsLoaded: boolean;
  isLoadingDefaultDeals: boolean;
}

const initialState: DealFinderState = {
  defaultDeals: [],
  isDefaultDealsLoaded: false,
  isLoadingDefaultDeals: false,
};

export const { actions, reducer } = createSlice({
  name: "dealFinder",
  initialState,
  reducers: {
    setLoadingDefaultDeals: (state, action) => {
      state.isLoadingDefaultDeals = action.payload;
    },
    setDefaultDeals: (state, action) => {
      state.defaultDeals = action.payload;
      state.isDefaultDealsLoaded = true;
      state.isLoadingDefaultDeals = false;
    },
    setDefaultDealsLoadError: (state) => {
      state.isLoadingDefaultDeals = false;
    },
    flush() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    // Reset state on logout actions
    logoutActions.forEach((actionType) => {
      builder.addCase(actionType, () => initialState);
    });
  },
});

export default reducer;
